export const MatchActionType = {
  RESET: 'reset',
  MISSING: 'missing',
  LATE: 'late',
  ATTENDING: 'attending',
  // NOTE: 'note',
  MORE: 'more',
} as const;
export type MatchActionType = typeof MatchActionType[keyof typeof MatchActionType];

export const MatchButtonType = {
  RESET: 'reset',
  MISSING: 'missing',
  LATE: 'late',
  ATTENDING: 'attending',
  MORE: 'more',
} as const;
export type MatchButtonType = typeof MatchButtonType[keyof typeof MatchButtonType];

export const ExtraMatchButtonType = {
  RESET_ALL: 'resetAll',
  MISSING_ALL: 'missingAll',
  ATTENDING_ALL: 'attendingAll',
  // NOTE: 'leave-note',
  PRIVACY: 'privacy',
  CONFIRM_REGI: 'confirmRegi',
} as const;
export type ExtraMatchButtonType = typeof ExtraMatchButtonType[keyof typeof ExtraMatchButtonType];

export const AutoMatchActionType = {
  NONE: 'none',
  ATTENDING: 'attending',
} as const;
export type AutoMatchActionType = typeof AutoMatchActionType[keyof typeof AutoMatchActionType];
